import {
    buildFilterSearchParams,
    initializeStayLengthRangeValidation,
    validateStayLengthRange
} from './search-filters/queryParams'

const filtersShowMoreButtons = document.querySelectorAll('.filters__show-more');

filtersShowMoreButtons.forEach(button => {
    button.addEventListener('click', () => {

        const section = button.closest('.filters__section');
        const extraCheckboxes = section.querySelectorAll('.extra-checkbox');
        const expanded = section.querySelector('.hidden') !== null;

        extraCheckboxes.forEach(cb => {
            cb.classList.toggle('hidden');
        });

        const text = expanded ? button.dataset.showLess : button.dataset.showMore;

        button.innerHTML = `
            <img src="/img/search-filters/arrow-down.svg" 
                 class="filters__arrow ${expanded ? "rotated" : ''}" 
                 alt="arrow-down" /> 
            ${text}
        `;
    });
});
const filtersBtn = document.querySelector('.filters-btn');
const filters = document.querySelector('.filters');
const filtersCloseBtn = document.querySelector('.filters__close-btn');

if (filters) {
    initializeStayLengthRangeValidation(filters)

    filters.addEventListener('submit', (event) => {
        event.preventDefault()

        const honeypot = filters.querySelector('input[name="required"]')

        if (honeypot && honeypot.value.trim() !== '') {
            return
        }

        if (!validateStayLengthRange(filters)) {
            return
        }

        const url = new URL(filters.action, window.location.origin)
        url.search = buildFilterSearchParams(filters).toString()

        window.location.assign(url.toString())
    })
}

/*document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.toggle-subcategories').forEach(label => {
        label.addEventListener('click', function(e) {
            // prevent checkbox toggling when only expanding
            if (e.target.tagName.toLowerCase() === 'input') return;

            const container = this.parentElement.querySelector('.filters__subcategories-container');
            if (container) {
                const isVisible = container.style.display === 'flex';
                container.style.display = isVisible ? 'none' : 'flex';

                // optional: rotate arrow icon
                const arrow = this.querySelector('.filters__arrow');
                if (arrow) arrow.style.transform = isVisible ? 'rotate(0deg)' : 'rotate(180deg)';
            }
        });
    });
});*/

document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.filters__operators-list');
    const shipmentCheckbox = document.querySelector('input[name="typ[]"][value="rejs"]');
    const mainHeader = document.querySelector('.main-header');
    const mainToggle = mainHeader ? mainHeader.querySelector('.main-operator-toggle') : null;

    if (container) {
        container.addEventListener('click', (e) => {
            const label = e.target.closest('.operator-label');
            if (!label) return;

            const block = label.closest('.operator-block');
            const subContainer = block.querySelector('.operator-subcategories');
            const mainCheckbox = label.querySelector('.operator-checkbox');

            if (e.target.closest('.filters__checkbox-checkmark')) {
                e.preventDefault(); // blokuje domyślne zachowanie labela

                const newState = !mainCheckbox.checked;
                mainCheckbox.checked = newState;

                const anyChecked = container.querySelector('input[type="checkbox"]:checked') !== null;
                if (mainToggle) {
                    mainToggle.checked = anyChecked;
                }

                if (subContainer) {
                    const subCheckboxes = subContainer.querySelectorAll('.sub-operator-checkbox');
                    //subCheckboxes.forEach(cb => cb.checked = newState);
                    //subContainer.classList.toggle('open', newState);
                }

                if (subContainer && !subContainer.classList.contains('open')) {
                    //subContainer.classList.add('open');
                    label.classList.add('open');
                }

                if (newState) {
                    shipmentCheckbox.checked = true;
                }
                //label.classList.toggle('open', newState);
                return;
            }

            if (!e.target.closest('input[type="checkbox"]')) {
                e.preventDefault();
                if (subContainer) {
                    const isOpen = subContainer.classList.toggle('open');
                    label.classList.toggle('open', isOpen);
                }
            }
        });

        container.addEventListener('change', (e) => {
            const target = e.target;
            const anyChecked = container.querySelector('input[type="checkbox"]:checked') !== null;

            if (mainToggle) {
                mainToggle.checked = anyChecked;
            }
            if (!target.classList.contains('sub-operator-checkbox')) return;

            const operatorBlock = target.closest('.operator-block');
            if (!operatorBlock) return;

            const parentCheckbox = operatorBlock.querySelector('.operator-checkbox');

            if (!parentCheckbox) return;
            const anySubChecked = operatorBlock.querySelectorAll('.sub-operator-checkbox:checked').length > 0;

            parentCheckbox.checked = anySubChecked;
            const anyCheckedVerification = container.querySelector('input[type="checkbox"]:checked') !== null;

            if (mainToggle) {
                mainToggle.checked = anyCheckedVerification;
            }
        });
    }

    if (mainHeader) {

        // prevent clicking label text from toggling all checkboxes by accident
        mainHeader.addEventListener('click', (e) => {
            // if click is not directly on the checkbox, don't toggle it
            if (e.target.classList.contains('filters__checkbox-checkmark')) {
                // simulate toggle
                if (mainToggle) {
                    mainToggle.checked = !mainToggle.checked;
                    if (mainToggle.checked) {
                        shipmentCheckbox.checked = true;
                    }
                    mainToggle.dispatchEvent(new Event('change'));
                }
                e.preventDefault();
            } else {
                // prevent toggling when clicking other parts of label
                e.preventDefault();

                const operatorListContainer = document.querySelector('.filters__operators-list');

                if (!operatorListContainer) {
                    return
                }

                operatorListContainer.classList.toggle('open');
                mainHeader.classList.toggle('open');
            }
        });

        if (mainToggle) {
            mainToggle.addEventListener('change', (e) => {
                const checked = e.target.checked;

                // toggle ALL operator + sub-operator checkboxes inside .filters__operators-list
                document
                    .querySelectorAll('.filters__operators-list input[type="checkbox"].operator-checkbox')
                    .forEach(cb => { cb.checked = checked; });
                const operatorListContainer = document.querySelector('.filters__operators-list');

                if (!operatorListContainer) {
                    return;
                }

                //operatorListContainer.classList.toggle('open');
            });
        }
    }
});

if (filtersBtn && filters) {
    filtersBtn.addEventListener("click", () => {
        filters.style.display = "block";
        document.body.classList.add("no-scroll");
    });
}

if (filtersCloseBtn && filters) {
    filtersCloseBtn.addEventListener("click", () => {
        filters.style.display = "none";
        document.body.classList.remove("no-scroll");
    });
}

// sort
const sortSelect = document.getElementById('trip-form-sort');

if (sortSelect) {
    sortSelect.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set(sortSelect.name, sortSelect.value);
        window.location.href = url.toString();
    })
}

const checkAll = document.getElementById('check-all-operators');
const checkboxes = document.querySelectorAll('.filters__checkbox-wrapper-input');

if (checkAll) {
    checkAll.addEventListener('change', function() {
        checkboxes.forEach(cb => cb.checked = checkAll.checked);
    });
}
